import find from 'lodash/find.js';

import Model from '@/models/Model.js';
import QueryBuilder from '@/utilities/QueryBuilder.js';

export const OWNER = 1;
export const ADMIN = 4;
export const ROLE_MANAGER = 7;
export const INSTRUCTION_ADMIN = 10;
export const INSTRUCTOR = 13;
export const TEACHING_ASSISTANT = 16;
/** @deprecated Prefer {@link STUDENT_ROLE_NAME} for role checks; numeric ids differ per database. */
export const STUDENT = 19;
/** Matches App\Models\Role::STUDENT — use for Vuex queries and getters instead of hardcoded role id. */
export const STUDENT_ROLE_NAME = 'Student';
export const CONTENT_EDITOR = 20;
export const TECHNICAL_WRITER = 23;
export const PAGE_EDITOR = 24;
export const STUDENT_SUPPORT = 27;
export const PASSIVE = 29;

export default class Role extends Model {
    static entity = 'roles';

    static assignableRolesRetrieved = false;

    static fields() {
        return {
            id: this.attr(null),
            name: this.attr(null),
            group_assignable: this.boolean(false),
            enrollment_assignable: this.boolean(false),
            guard_name: this.attr(null),
            pivot: this.attr(null),

            ...super.fields(),

            permissions: this.belongsToMany('permissions', 'role_has_permissions', 'role_id', 'permission_id'),
            user_groups: this.hasMany('user_groups', 'role_id'),
        };
    }

    static beforeCreate(model) {
        // Create the pivot model manually if it exists on the model
        if (model.pivot) {
            Role.insertOrUpdate({ data: model.pivot });
        }
    }

    static queryBuilder(id = null) {
        const param = id ? `/${id}` : '';

        return new QueryBuilder(this.entity + param);
    }

    static async fetch() {
        const { response } = await this.api().get(this.queryBuilder().toUrl());

        return response.data;
    }

    static async fetchAssignableRoles() {
        if (!Role.assignableRolesRetrieved) {
            const response = Role.api().get('/api/assignable-roles?model=user_group');
            Role.assignableRolesRetrieved = true;

            return response;
        }

        return new Promise(resolve => resolve());
    }

    hasPermissionTo(permission) {
        return Boolean(find(this.permissions, { name: permission }));
    }
}
